export default __webpack_public_path__ + "static/media/careers-teams-picture.c31756f5.jpg";